import "@rmlibrary/scroll";
import "./cjs-animations";
import "./common";
import "./accordion";

import {
    barGraphResize,
    buildDiversificationBarGraph,
    drawDiversificationPieGraphs,
    mouseenterPieGraphAnimation,
    mouseleavePieGraphAnimation,
    pieGraphResize
} from "./graphing";
import { generatePDF, setupPreview } from "./pdf";

import $ from "jquery";
import Formatter from "@rmlibrary/formatting";
import { getDiversificationResults } from "./calculations";
import { roundNumber } from "./utilities";

// Allow results/widths to be used outside of main function
let pieGraphResults;
let tableResults;
let pieGraphSection = "stocks";
let tableBuilt = false;
let graphAnimated = false;

const checkboxClasses = [
    "canadian-small",
    "us-equities",
    "canadian-equities",
    "canadian-bonds",
    "international-equities",
    "emerging-markets",
    "us-small",
    "global-bonds",
    "canadian-home-prices"
];
const lang = document.documentElement.lang.toLowerCase().indexOf("fr") >= 0 ? "fr" : "en";
const formatter = new Formatter(lang);
const pdfReportButton = $("#pdf-btn");
const graphDisplayYears = {
    desktop: {
        left: {
            min: 2008,
            max: 2017
        },
        middle: {
            min: null,
            max: null
        },
        right: {
            min: 2016,
            max: 2025
        }
    },
    mobile: {
        left: {
            min: 2008,
            max: 2013
        },
        middle: {
            min: 2014,
            max: 2019
        },
        right: {
            min: 2020,
            max: 2025
        }
    }
};
let currentGraphSize = "desktop";

const allRotationButtons = document.querySelectorAll(".rotate-left, .rotate-middle, .rotate-right");
allRotationButtons.forEach((button) => {
    button.addEventListener("click", () => {
        document.querySelector(".diversification-table").focus();
    });
});

// Overarching function to export
export function buildDiversificationGraphs(hub) {
    if (!hub) hub = tableBuilt;
    //Function runs if 'pie-graph-container' div on page
    const diversificationPromise = new Promise((resolve) => {
        if ($(".pie-graph-container").length > 0) {
            getDiversificationResults(resolve);
        }
    });

    //Store results data and trigger pie build with diversification results
    diversificationPromise.then((results) => {
        pieGraphResults = {
            canadaStocks: results.stocks.canada,
            worldStocks: results.stocks.world,
            canadaSectors: results.sectors.canada,
            worldSectors: results.sectors.world
        };

        tableResults = results.growth;

        pastePieGraphResults(pieGraphResults);
        if (!hub) {
            buildDiversificationTable();
            tableBuilt = true;
        }
        if (hub) {
            drawDiversificationPieGraphs(pieGraphResults);
        }

        // Bar graph builds id 'bar-graph-container' div on page
        if ($(".bar-graph-container").length > 0) {
            buildDiversificationBarGraph(tableResults);
        }
    });
}

const pastePieGraphResults = (results) => {
    results.canadaStocks.breakdown.forEach((result) => {
        const item = $("<div>");
        const displayText = $(`<p aria-hidden='true'>${result.name}</p>`);
        const srText = $(
            `<p class='sr-only'>${result.name
                .replace('<span class="percentage-red">', "")
                .replace("</span>", " - ")}</p>`
        );
        item.append(displayText);
        item.append(srText);
        $(".canada-stocks").append(item);
    });

    results.worldStocks.breakdown.forEach((result) => {
        const item = $("<div>");
        const displayText = $(`<p aria-hidden='true'>${result.name}</p>`);
        const srText = $(
            `<p class='sr-only'>${result.name
                .replace('<span class="percentage-blue">', "")
                .replace("</span>", " - ")}</p>`
        );
        item.append(displayText);
        item.append(srText);
        $(".world-stocks").append(item);
    });

    results.canadaSectors.breakdown.forEach((result) => {
        const item = $("<div>");
        const displayText = $(`<p aria-hidden='true'>${result.name}</p>`);
        const srText = $(
            `<p class='sr-only'>${result.name
                .replace('<span class="percentage-red">', "")
                .replace("</span>", " - ")}</p>`
        );
        item.append(displayText);
        item.append(srText);
        $(".canada-sectors").append(item);
    });

    results.worldSectors.breakdown.forEach((result) => {
        const item = $("<div>");
        const displayText = $(`<p aria-hidden='true'>${result.name}</p>`);
        const srText = $(
            `<p class='sr-only'>${result.name
                .replace('<span class="percentage-blue">', "")
                .replace("</span>", " - ")}</p>`
        );
        item.append(displayText);
        item.append(srText);
        $(".world-sectors").append(item);
    });
};

const touchTracking = () => {
    var startX = 0,
        startY = 0,
        endX = 0,
        endY = 0,
        movementX = 0,
        movementY = 0,
        lastX = 0,
        lastY = 0;

    $(".diversification-table")[0].addEventListener("touchstart", function (e) {
        startX = e.changedTouches[0].clientX;
        startY = e.changedTouches[0].clientY;
    });

    $(".diversification-table")[0].addEventListener("touchmove", function (e) {
        if (Math.abs(e.changedTouches[0].clientX - lastX) + 10 > Math.abs(e.changedTouches[0].clientY - lastY)) {
            e.preventDefault();
        }
        lastX = e.changedTouches[0].clientX;
        lastY = e.changedTouches[0].clientY;
    });

    $(".diversification-table")[0].addEventListener("touchend", function (e) {
        endX = e.changedTouches[0].clientX;
        endY = e.changedTouches[0].clientY;
        movementX = endX - startX;
        movementY = endY - startY;

        if (movementX > 60 && Math.abs(movementX) > Math.abs(movementY)) {
            if ($(".rotate-middle.dot").is(":visible") && $(".rotate-right.dot").hasClass("selected")) {
                rotateMiddle();
            } else {
                rotateLeft();
            }
        } else if (movementX < -60 && Math.abs(movementX) > Math.abs(movementY)) {
            if ($(".rotate-middle.dot").is(":visible") && $(".rotate-left.dot").hasClass("selected")) {
                rotateMiddle();
            } else {
                rotateRight();
            }
        }
    });
};

//Building dynamic table
function buildDiversificationTable() {
    // Gets the last year of the ten year period
    let lastYearInGrowth = 0;
    for (let yearString in tableResults[0]) {
        const year = Number(yearString);
        if (!isNaN(year) && year > lastYearInGrowth) {
            lastYearInGrowth = year;
        }
    }

    tableResults.forEach((stock, i) => {
        if (stock.id !== "BalancedPortfolio") {
            // Builds checkbox for each item in tableResults array using 'base' on html
            const newCheckbox = $(".checkbox-div-base").clone().removeClass("checkbox-div-base");
            $(newCheckbox).find("input").attr("id", stock.id);
            $(newCheckbox).find("label").attr("for", stock.id).find(".text").html(stock.name);
            $(newCheckbox).find(".graph-legend").removeClass("dark-purple").addClass(stock.class);
            $(newCheckbox).find(".icon-hover-index").html(stock.stockIndex);
            $(".checkbox-wrapper").append(newCheckbox);
        }

        // Builds row for each item in tableResults array using 'base' on html
        const tableRow = $(".results-base")
            .clone()
            .removeClass("results-base")
            .addClass("results" + i);
        $(".diversification-table").append(tableRow);
    });

    // Removes base html elements
    $(".results-base").remove();
    $(".checkbox-div-base").remove();

    //Get results by year
    let resultsByYear = orderByYears(tableResults, lastYearInGrowth);
    pasteResultsIntoTable(resultsByYear, lastYearInGrowth);
    rotateTable();
    touchTracking();
}

function updateGraphButtonLabels() {
    $(".rotate-left.dot").attr(
        "aria-label",
        `${lang === "en" ? "See rates from" : "Voir les taux de"} ${graphDisplayYears[currentGraphSize].left.min} ${
            lang === "en" ? "to" : "à"
        } ${graphDisplayYears[currentGraphSize].left.max}`
    );
    $(".rotate-left.arrow").attr(
        "aria-label",
        `${lang === "en" ? "See rates from" : "Voir les taux de"} ${graphDisplayYears[currentGraphSize].left.min} ${
            lang === "en" ? "to" : "à"
        } ${graphDisplayYears[currentGraphSize].left.max}`
    );
    $(".rotate-middle.dot").attr(
        "aria-label",
        `${lang === "en" ? "See rates from" : "Voir les taux de"} ${graphDisplayYears[currentGraphSize].middle.min} ${
            lang === "en" ? "to" : "à"
        } ${graphDisplayYears[currentGraphSize].middle.max}`
    );
    $(".rotate-right.dot").attr(
        "aria-label",
        `${lang === "en" ? "See rates from" : "Voir les taux de"} ${graphDisplayYears[currentGraphSize].right.min} ${
            lang === "en" ? "to" : "à"
        } ${graphDisplayYears[currentGraphSize].right.max}`
    );
    $(".rotate-right.arrow").attr(
        "aria-label",
        `${lang === "en" ? "See rates from" : "Voir les taux de"} ${graphDisplayYears[currentGraphSize].right.min} ${
            lang === "en" ? "to" : "à"
        } ${graphDisplayYears[currentGraphSize].right.max}`
    );
}

function rotateTable() {
    if (currentGraphSize === "desktop") {
        if ($(".rotate-middle.dot").hasClass("selected")) {
            $(".rotate-middle.dot").removeClass("selected");
            $(".rotate-right.dot").addClass("selected");
        }

        if ($(".rotate-left.dot").hasClass("selected")) {
            rotateLeft();
        } else {
            rotateRight();
        }

        $(".rotate-middle.dot").hide();
    } else {
        if ($(".rotate-left.dot").hasClass("selected")) {
            rotateLeft();
        } else if ($(".rotate-middle.dot").hasClass("selected")) {
            rotateMiddle();
        } else {
            rotateRight();
        }

        $(".rotate-middle.dot").show();
    }

    if ($(".rotate-middle.dot").is(":visible") && $(".rotate-middle.dot").hasClass("selected")) {
        $("#left-arrow").css("visibility", "visible");
        $("#right-arrow").css("visibility", "visible");
    } else if ($(".rotate-left.dot").hasClass("selected")) {
        $("#left-arrow").css("visibility", "hidden");
        $("#right-arrow").css("visibility", "visible");
    } else if ($(".rotate-right.dot").hasClass("selected")) {
        $("#right-arrow").css("visibility", "hidden");
        $("#left-arrow").css("visibility", "visible");
    }

    $(".rotating-table")
        .find(".rotate-left")
        .off()
        .on("click", (event) => {
            event.preventDefault();

            if (
                $(event.target).is("button") &&
                $(".rotate-middle.dot").is(":visible") &&
                $(".rotate-right.dot").hasClass("selected")
            ) {
                rotateMiddle();
            } else {
                rotateLeft();
            }
        });

    $(".rotating-table")
        .find(".rotate-middle")
        .off()
        .on("click", (event) => {
            event.preventDefault();
            rotateMiddle();
        });

    $(".rotating-table")
        .find(".rotate-right")
        .off()
        .on("click", (event) => {
            event.preventDefault();

            if (
                $(event.target).is("button") &&
                $(".rotate-middle.dot").is(":visible") &&
                $(".rotate-left.dot").hasClass("selected")
            ) {
                rotateMiddle();
            } else {
                rotateRight();
            }
        });
}

function rotateLeft() {
    if (currentGraphSize === "desktop") {
        for (let i = 8; i < 18; i++) {
            $(`.column${i}`).addClass("hide");
        }

        setTimeout(() => {
            for (let i = 0; i < 10; i++) {
                $(`.column${i}`).removeClass("hide");
            }
        });
    } else {
        for (let i = 0; i < 6; i++) {
            $(`.column${i}`).removeClass("hide");
        }

        for (let i = 6; i < 12; i++) {
            $(`.column${i}`).addClass("hide");
        }

        for (let i = 12; i < 18; i++) {
            $(`.column${i}`).addClass("hide");
        }

        $(".rotate-middle.dot").removeClass("selected");
    }

    if (currentGraphSize === "desktop") {
        $(".rotate-right.arrow").attr(
            "aria-label",
            `${lang === "en" ? "See rates from" : "Voir les taux de"} ${
                graphDisplayYears[currentGraphSize].right.min
            } ${lang === "en" ? "to" : "à"} ${graphDisplayYears[currentGraphSize].right.max}`
        );
    } else {
        $(".rotate-right.arrow").attr(
            "aria-label",
            `${lang === "en" ? "See rates from" : "Voir les taux de"} ${
                graphDisplayYears[currentGraphSize].middle.min
            } ${lang === "en" ? "to" : "à"} ${graphDisplayYears[currentGraphSize].middle.max}`
        );
    }

    $(".rotate-left.dot").addClass("selected");
    $(".rotate-right.dot").removeClass("selected");
    $("#left-arrow").css("visibility", "hidden");
    $("#right-arrow").css("visibility", "visible");

    $(".graph-rotate-alert").text(
        `${lang === "en" ? "Displaying rates for" : "Affichage des taux de"} ${
            graphDisplayYears[currentGraphSize].left.min
        } ${lang === "en" ? "to" : "à"} ${graphDisplayYears[currentGraphSize].left.max}`
    );
    setTimeout(() => {
        $(".graph-rotate-alert").text("");
    }, 100);
}

function rotateMiddle() {
    for (let i = 0; i < 6; i++) {
        $(`.column${i}`).addClass("hide");
    }

    for (let i = 6; i < 12; i++) {
        $(`.column${i}`).removeClass("hide");
    }

    for (let i = 12; i < 18; i++) {
        $(`.column${i}`).addClass("hide");
    }

    if (currentGraphSize === "mobile") {
        $(".rotate-left.arrow").attr(
            "aria-label",
            `${lang === "en" ? "See rates from" : "Voir les taux de"} ${graphDisplayYears[currentGraphSize].left.min} ${
                lang === "en" ? "to" : "à"
            } ${graphDisplayYears[currentGraphSize].left.max}`
        );
        $(".rotate-right.arrow").attr(
            "aria-label",
            `${lang === "en" ? "See rates from" : "Voir les taux de"} ${
                graphDisplayYears[currentGraphSize].right.min
            } ${lang === "en" ? "to" : "à"} ${graphDisplayYears[currentGraphSize].right.max}`
        );
    }

    $(".rotate-left.dot").removeClass("selected");
    $(".rotate-middle.dot").addClass("selected");
    $(".rotate-right.dot").removeClass("selected");
    $("#left-arrow").css("visibility", "visible");
    $("#right-arrow").css("visibility", "visible");

    $(".graph-rotate-alert").text(
        `${lang === "en" ? "Displaying rates for" : "Affichage des taux de"} ${
            graphDisplayYears[currentGraphSize].middle.min
        } ${lang === "en" ? "to" : "à"} ${graphDisplayYears[currentGraphSize].middle.max}`
    );
    setTimeout(() => {
        $(".graph-rotate-alert").text("");
    }, 100);
}

function rotateRight() {
    if (currentGraphSize === "desktop") {
        for (let i = 0; i < 10; i++) {
            $(`.column${i}`).addClass("hide");
        }

        setTimeout(() => {
            for (let i = 8; i < 18; i++) {
                $(`.column${i}`).removeClass("hide");
            }
        });
    } else {
        for (let i = 0; i < 6; i++) {
            $(`.column${i}`).addClass("hide");
        }

        for (let i = 6; i < 12; i++) {
            $(`.column${i}`).addClass("hide");
        }

        for (let i = 12; i < 18; i++) {
            $(".column" + i).removeClass("hide");
        }

        $(".rotate-middle.dot").removeClass("selected");
    }

    if (currentGraphSize === "desktop") {
        $(".rotate-left.arrow").attr(
            "aria-label",
            `${lang === "en" ? "See rates from" : "Voir les taux de"} ${graphDisplayYears[currentGraphSize].left.min} ${
                lang === "en" ? "to" : "à"
            } ${graphDisplayYears[currentGraphSize].left.max}`
        );
    } else {
        $(".rotate-left.arrow").attr(
            "aria-label",
            `${lang === "en" ? "See rates from" : "Voir les taux de"} ${
                graphDisplayYears[currentGraphSize].middle.min
            } ${lang === "en" ? "to" : "à"} ${graphDisplayYears[currentGraphSize].middle.max}`
        );
    }

    $(".rotate-left.dot").removeClass("selected");
    $(".rotate-right.dot").addClass("selected");
    $("#left-arrow").css("visibility", "visible");
    $("#right-arrow").css("visibility", "hidden");

    $(".graph-rotate-alert").text(
        `${lang === "en" ? "Displaying rates for" : "Affichage des taux de"} ${
            graphDisplayYears[currentGraphSize].right.min
        } ${lang === "en" ? "to" : "à"} ${graphDisplayYears[currentGraphSize].right.max}`
    );
    setTimeout(() => {
        $(".graph-rotate-alert").text("");
    }, 100);
}

const pasteResultsIntoTable = (results, finalYear) => {
    // Paste years into th cells
    let year = finalYear - 17;
    $(".heading-row")
        .find("th")
        .each((i, cell) => {
            $(cell).html(year);
            year++;
        });
    for (let year in results) {
        // For every year, cycle down the row and paste values from highest to lowest
        results[year].forEach((unit, i) => {
            const column = -finalYear + Number(year) + 17;
            const cell = $(".results" + i).find("td")[column];
            const mouseOver = $('<div class="name-hover">').text(unit.stock);
            const roundedPercent = roundNumber(Number(Number(unit.rate * 100).toFixed(2)), 1);
            const percent = $("<span></span>").html(formatter.formatPercentage(roundedPercent, 1));

            $(cell)
                .addClass(unit.class)
                .attr("data-stock", unit.class)
                .find(".column-child")
                .append(mouseOver)
                .append(percent);
        });
    }

    //When checkboxes are checked or unchecked, add or remove 'overlay' class.
    $('input[name="checkboxGroup1"]').on("change", function () {
        const checkboxId = $(this)[0].id;
        const checked = $(this).prop("checked");

        if (checkboxId === "SelectAll") {
            let balancedChecked = $("#BalancedPortfolio").prop("checked");
            $('input[name="checkboxGroup1"]').prop("checked", checked);
            if (checked) {
                checkboxClasses.forEach(function (checkboxClass) {
                    $("." + checkboxClass + " .table-overlay").removeClass("unselected");
                    $("." + checkboxClass + " .table-overlay")
                        .parent()
                        .css("border", "");
                    changeTextVisibility(checkboxClass, checked);
                });
            } else {
                checkboxClasses.forEach(function (checkboxClass) {
                    $("." + checkboxClass + " .table-overlay").addClass("unselected");
                    $("." + checkboxClass + " .table-overlay")
                        .parent()
                        .css("border", "none");
                    changeTextVisibility(checkboxClass, checked);
                });
            }

            // The balanced checkbox and table values should not be affected by select all
            $("#BalancedPortfolio").prop("checked", balancedChecked);
        } else {
            let checkboxClass;
            tableResults.forEach((result) => {
                if (checkboxId === result.id) checkboxClass = result.class;
            });

            if (checked) {
                $("." + checkboxClass + " .table-overlay").removeClass("unselected");
                $("." + checkboxClass + " .table-overlay")
                    .parent()
                    .css("border", "");
                changeTextVisibility(checkboxClass, checked);
                if (
                    $(".asset-checkboxes").find("input:not(#SelectAll):checked").length ===
                    $(".asset-checkboxes").find("input:not(#SelectAll)").length
                ) {
                    $("#SelectAll").prop("checked", checked);
                }
            } else {
                $("." + checkboxClass + " .table-overlay").addClass("unselected");
                $("." + checkboxClass + " .table-overlay")
                    .parent()
                    .css("border", "1px solid transparent");
                $("#SelectAll").prop("checked", checked);
                changeTextVisibility(checkboxClass, checked);
            }
        }
    });
};

function changeTextVisibility(checkboxClass, checked) {
    let boxText = $("." + checkboxClass + " .column-child").find("span");
    let hoverText = $("." + checkboxClass + " .column-child").find("div.name-hover");
    if (checked) {
        for (let i = 0; i < boxText.length; i++) {
            boxText.show();
            hoverText.show();
        }
    } else if (!checked) {
        for (let i = 0; i < boxText.length; i++) {
            boxText.hide();
            hoverText.hide();
        }
    }
}

// Ordering table results by years for pasting into table
const orderByYears = (results, finalYear) => {
    let newResults = {};

    // Loop through years
    for (let i = finalYear - 17; i <= finalYear; i++) {
        let yearlyResults = [];

        // For each of the last ten years, get stock data
        results.forEach((stockItem) => {
            const unit = {
                stock: stockItem.name,
                rate: stockItem[i.toString()],
                class: stockItem.class
            };

            yearlyResults.push(unit);
        });

        // Order stock data by highest rates
        const orderedYearlyResults = yearlyResults.sort((a, b) => {
            return a.rate < b.rate ? 1 : -1;
        });

        newResults[i.toString()] = orderedYearlyResults;
    }

    return newResults;
};

// If window is resized, call this function
function windowResizeFunction() {
    const screenWidth = $(window).width();
    if (screenWidth >= 576) {
        currentGraphSize = "desktop";
    } else {
        currentGraphSize = "mobile";
    }
    pieGraphResize(pieGraphResults, pieGraphSection);
    barGraphResize(tableResults);
    updateGraphButtonLabels();
    rotateTable();
}

function setupSmoothScrollingToSections() {
    const { hash } = location;
    const sectionIDs = [
        "portfolios-at-a-glance",
        "going-global",
        "les-solutions-de-portefeuille-en-bref",
        "investir-a-letranger"
    ];
    const hasSectionID = sectionIDs.some((sectionID) => hash.includes(sectionID));

    if (hasSectionID) {
        $("body").one("animationstart", () => (document.location.href = hash));
    }
}

function unhideIcon() {
    $("#pgNavTaggle").on("click", () => {
        $(".fa-chevron-up").css("display", "");
    });
}

$(() => {
    if (window.location.search === "?pdf") {
        setupPreview();
        return;
    }

    unhideIcon();

    // reset form input values on IE browser refresh
    $("#portfolio-selection-form").trigger("reset");

    const diversificationPromise = new Promise((resolve) => {
        if ($(".pie-graph-container").length > 0) {
            getDiversificationResults(resolve);
        }
    });

    diversificationPromise.then((results) => {
        pieGraphResults = {
            canadaStocks: results.stocks.canada,
            worldStocks: results.stocks.world,
            canadaSectors: results.sectors.canada,
            worldSectors: results.sectors.world
        };
    });

    $(".diversification-pie-graphs").on("do-animation", function () {
        if (!graphAnimated) {
            setTimeout(() => {
                drawDiversificationPieGraphs(pieGraphResults, "stocks");
                drawDiversificationPieGraphs(pieGraphResults, "sectors");
            }, 800);
            graphAnimated = true;
        }
    });

    if ($(".diversification-table").length > 0) {
        buildDiversificationGraphs();
    }

    $(".diversification-table").on("mouseover", "td", function (event) {
        const stockClass = $(this).attr("data-stock");
        $("." + stockClass)
            .addClass("hover-state")
            .each(function (i, el) {
                // Prevent double lines when the same stock classes are on top of each other.
                const columnClass = $(el).attr("class").split(" ")[0];
                const previousRowSameElementExists =
                    $(el).parent().prev().find(`.${columnClass}[data-stock='${stockClass}']`).length > 0;
                if (previousRowSameElementExists) {
                    $(el).find("> .column-child").addClass("no-top-border");
                }

                // Prevent double lines when the same stock classes are next to each other.
                const previousColumnSameElementExists = $(el).prev(`[data-stock='${stockClass}']`).length > 0;
                if (previousColumnSameElementExists) {
                    $(el).find("> .column-child").addClass("no-left-border");
                }
            });

        showPopup(stockClass, event);
    });

    $(".diversification-table").on("mouseout", "td", function () {
        const stockClass = $(this).attr("data-stock");
        $("." + stockClass).removeClass("hover-state");
        hidePopup();
    });

    function hidePopup() {
        const hoverBubble = $(".hover-bubble");
        hoverBubble.removeClass("hover-bubble-show");
    }

    function showPopup(stockClass, event) {
        const stockData = tableResults.find((r) => r.class === stockClass);
        const name = stockData.name;
        const hoverBubble = $(".hover-bubble");
        hoverBubble.addClass("hover-bubble-show");
        hoverBubble.text(name);

        const hoverWrapper = $(".hover-wrapper");

        if (event.target) {
            let target = event.target;
            if (target.tagName === "SPAN") {
                target = target.parentElement;
            }

            const halfWidth = hoverBubble.width() / 2;
            var offset = target.getBoundingClientRect();
            var posY = offset.top - 30;
            var posX = offset.left - halfWidth + target.offsetWidth / 2;

            hoverWrapper.css("left", posX + "px");
            hoverWrapper.css("top", posY + "px");
        }
    }

    const tds = document.querySelector(".diversification-table").querySelectorAll("td");
    tds.forEach((td) => {
        td.tabIndex = 0;
    });

    $(".diversification-table").on("focus", "td", function (event) {
        const stockClass = $(this).attr("data-stock");
        showPopup(stockClass, event);
    });

    $(".diversification-table").on("blur", "td", function (event) {
        hidePopup();
    });

    $(".pie-graph-container").on("mouseenter", (event) => {
        const pieGraphActive = $(event.target).closest(".pie-graph-container").attr("name");
        pieGraphSection = pieGraphActive.toLowerCase().indexOf("sectors") > -1 ? "sectors" : "stocks";
        mouseenterPieGraphAnimation(pieGraphResults, pieGraphSection, pieGraphActive);
    });
    $(".pie-graph-container").on("mouseleave", (event) => {
        const pieGraphActive = $(event.target).closest(".pie-graph-container").attr("name");
        pieGraphSection = pieGraphActive.toLowerCase().indexOf("sectors") > -1 ? "sectors" : "stocks";
        mouseleavePieGraphAnimation(pieGraphResults, pieGraphSection, pieGraphActive);
    });

    // Toggle between 'Top 10 stocks' and 'Top 10 sectors' on diversification page.
    // $(".sectors-tab").on("click", function () {
    //     pieGraphSection = "sectors";
    //     $(".stocks-tab").removeClass("selected");
    //     $(".stocks").removeClass("selected");
    //     $(".sectors-tab").addClass("selected");
    //     $(".sectors").addClass("selected");
    //     drawDiversificationPieGraphs(pieGraphResults, pieGraphSection);
    //     position_indicator($(".tab-content").find(".selected"));
    // });

    // Toggle between 'Top 10 stocks' and 'Top 10 sectors' on diversification page.
    // $(".stocks-tab").on("click", function () {
    //     pieGraphSection = "stocks";
    //     $(".sectors-tab").removeClass("selected");
    //     $(".sectors").removeClass("selected");
    //     $(".stocks-tab").addClass("selected");
    //     $(".stocks").addClass("selected");
    //     drawDiversificationPieGraphs(pieGraphResults, pieGraphSection);
    //     position_indicator($(".tab-content").find(".selected"));
    // });

    // Hack to remove extra table cell padding on iOS and Safari on Mac devices.
    const userAgent = navigator.userAgent.toLowerCase();
    const vendor = navigator.vendor.toLowerCase();
    if (userAgent.match(/(ipad|iphone|ipod)/i)) {
        $(".column-child").addClass("ios");
    } else if (userAgent.match(/macintosh/i) && vendor.match(/apple/i)) {
        $(".column-child").addClass("safari-mac");
    }

    // Window resize event
    window.addEventListener("resize", () => windowResizeFunction());

    let printPdf = function (url) {
        let iframe = this._printIframe;
        if (!this._printIframe) {
            iframe = this._printIframe = document.createElement("iframe");
            document.body.appendChild(iframe);

            iframe.style.display = "none";
            iframe.onload = function () {
                setTimeout(function () {
                    iframe.focus();
                    iframe.contentWindow.print();
                }, 1);
            };
        }

        iframe.src = url;
    };

    $("#print-chart").on("click", () => {
        if (navigator.pdfViewerEnabled) {
            printPdf(generatePDF(null, true));
        } else {
            window.open(generatePDF(null, true, true), "_blank");
        }
    });

    pdfReportButton.on("click", () => {
        const value = new Date();
        const format = lang === "en" ? "mmmm ddd, yyyy" : "ddd mmmm yyyy";
        $("#pdf-current-date").text(formatter.formatDate(value, format));

        generatePDF();
    });

    setupSmoothScrollingToSections();
});
